export const passwordGuidelines = [
    "At least 8 characters long",
    "Password cannot contain any spaces",
    "At least 1 uppercase and/or 1 lowercase letters",
    "At least 1 number and alphabet character"
]